import { Box, Link } from "@mui/material";
import { AttachFile } from "@mui/icons-material";
import type { VendorProfileDocument } from "../types";
import { isSafeHttpOrBlobUrl, isSafeHttpUrl } from "../utils/safeUrl";

type Props = {
  document?: VendorProfileDocument;
  // Opt-in for local-preview call sites that intentionally pass a
  // URL.createObjectURL() output. Default false so the vendor-data usage
  // sites (Profile & Edits, Current value) stay strict against blob:/data:.
  allowBlobUrl?: boolean;
};

export function AttachmentDisplay({ document, allowBlobUrl = false }: Props) {
  if (!document) return <>—</>;
  const label = document.file || "Open attachment";
  const rawHref = document.download_url ?? document.cdn_url ?? undefined;
  const guard = allowBlobUrl ? isSafeHttpOrBlobUrl : isSafeHttpUrl;
  const href = guard(rawHref) ? rawHref : undefined;
  if (!href) {
    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          color: "text.secondary",
          fontSize: 13,
          fontWeight: 500,
        }}
      >
        <AttachFile sx={{ fontSize: 14 }} />
        {label}
      </Box>
    );
  }
  return (
    <Box
      component={Link}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        color: "primary.main",
        textDecoration: "none",
        fontSize: 13,
        fontWeight: 500,
        "&:hover": { textDecoration: "underline" },
      }}
    >
      <AttachFile sx={{ fontSize: 14 }} />
      {label}
    </Box>
  );
}

export default AttachmentDisplay;
